<template>
  <a v-if="layout === 'inline'"
    :href="phoneLink"
    class="link--text"
  >
    <v-icon color="link">phone</v-icon>
    <strong class="ml-1">{{ phoneNumber }}</strong>
  </a>
  <a v-else
    :href="phoneLink"
    class="link--text mt-1 full-width wf-justify-content-center wf-align-items-center"
  >
    <v-icon color="link">phone</v-icon>
    <strong class="ml-1">{{ phoneNumber }}</strong>
  </a>
</template>

<script>
  export default {
    name: 'PhoneLink',
    props: {
      phoneNumber: {
        type: String,
        default: ''
      },
      layout: {
        type: String,
        default: ''
      },
    },
    computed: {
      phoneLink () {
        return 'tel:' + this.phoneNumber
      }
    }
  }
</script>
